module.exports = __webpack_public_path__ + "player/libopenmpt.js.mem";